import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : 'http://localhost:3400/api';

// Crear instancia separada para llamadas admin
const adminApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor específico para admin
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminService = {
  login: async (credentials) => {
    try {
      const response = await adminApi.post('/admin/login', credentials);
      const { token } = response.data;
      localStorage.setItem('adminToken', token);
      return response.data;
    } catch (error) {
      console.error('Error en login:', error);
      throw error;
    }
  },

  getCampaigns: async () => {
    try {
      const response = await adminApi.get('/admin/campaigns');
      return response.data;
    } catch (error) {
      console.error('Error obteniendo campañas:', error);
      throw error;
    }
  },

  getCampaign: async (id) => {
    try {
      const response = await adminApi.get(`/admin/campaigns/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo campaña:', error);
      throw error;
    }
  },

  createCampaign: async (campaignData) => {
    try {
      const response = await adminApi.post('/admin/campaigns', campaignData);
      return response.data;
    } catch (error) {
      console.error('Error creando campaña:', error);
      throw error;
    }
  },

  updateCampaign: async (id, campaignData) => {
    try {
      const response = await adminApi.put(`/admin/campaigns/${id}`, campaignData);
      return response.data;
    } catch (error) {
      console.error('Error actualizando campaña:', error);
      throw error;
    }
  },

  deleteCampaign: async (id) => {
    try {
      const response = await adminApi.delete(`/admin/campaigns/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error eliminando campaña:', error);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('adminToken');
  },

  resetCampaign: async (id) => {
    try {
      const response = await adminApi.post(`/admin/campaigns/${id}/reset`);
      return response.data;
    } catch (error) {
      console.error('Error resetting campaign:', error);
      throw error;
    }
  },

  resetBusinessPassword: async (id) => {
    try {
      const response = await adminApi.post(`/admin/campaigns/${id}/reset-password`);
      return response.data;
    } catch (error) {
      console.error('Error resetting business password:', error);
      throw error;
    }
  },

  verifyToken: async (token) => {
    try {
      const response = await adminApi.post('/admin/verify-token', { token });
      return response.data.isValid;
    } catch (error) {
      console.error('Error verificando token:', error);
      return false;
    }
  },

  // Dominios
  getDomains: async () => {
    const response = await adminApi.get('/admin/domains');
    return response.data;
  },

  getDomain: async (id) => {
    const response = await adminApi.get(`/admin/domains/${id}`);
    return response.data;
  },

  createDomain: async (domainData) => {
    const response = await adminApi.post('/admin/domains', domainData);
    return response.data;
  },

  updateDomain: async (id, domainData) => {
    const response = await adminApi.put(`/admin/domains/${id}`, domainData);
    return response.data;
  },

  deleteDomain: async (id) => {
    const response = await adminApi.delete(`/admin/domains/${id}`);
    return response.data;
  },

  // API keys
  getApiKeys: async () => {
    const response = await adminApi.get('/admin/api-keys');
    return response.data;
  },

  createApiKey: async (data) => {
    const response = await adminApi.post('/admin/api-keys', data);
    return response.data;
  },

  updateApiKey: async (id, data) => {
    const response = await adminApi.put(`/admin/api-keys/${id}`, data);
    return response.data;
  },

  deleteApiKey: async (id) => {
    const response = await adminApi.delete(`/admin/api-keys/${id}`);
    return response.data;
  },
}; 